import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class StreamingService {
  constructor(private http: HttpService) {}

  socketSubject = new Subject<void>();
  list_auctions: any = [];

  watchSocket() {
    return this.socketSubject.asObservable();
  }

  unwatchSocket() {
    this.socketSubject.unsubscribe();
  }

  changeSocket(action: any): void {
    this.socketSubject.next(action);
  }

  get auctions() {
    return this.list_auctions;
  }

  set auctions(obj: any) {
    this.list_auctions = obj;
  }

  openedScheldule(): Observable<any> {
    return this.http.get<any>(`core/opened-schedule2/`);
  }

  entranceOrder(id: any): Observable<any> {
    return this.http.get<any>(`core/entrance-order/?schedule_event=${id}`);
  }
}
